<ul class="error-messages">
  <li *ngFor="let errorMessage of errorMessages">{{ errorMessage }}</li>
</ul>
